import React, { useState, useEffect } from 'react';
import axios from 'axios';

const AddAttendance = () => {
  const storedSessionId = localStorage.getItem('currentSessionId');
  const selectedClassId = localStorage.getItem('selectedClassId');
  const selectedSectionName = localStorage.getItem('selectedSectionName');

  const [selectedSession] = useState(storedSessionId || '');
  const [selectedClass, setSelectedClass] = useState(selectedClassId || '');
  const [selectedSection, setSelectedSection] = useState(selectedSectionName || '');
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [students, setStudents] = useState([]);
  const [attendance, setAttendance] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [alreadySubmitted, setAlreadySubmitted] = useState(false);

  const labelStyle = "block text-black font-semibold text-[18px] mb-2";
  const inputStyle = "w-full px-3 py-2 border border-gray-300 rounded-md text-[14px] focus:ring-2 focus:ring-blue-500 placeholder:text-[14px] placeholder:text-gray-400";

  // Fetch classes for the selected session
  useEffect(() => {
    if (!selectedSession) return;

    axios.get(` ${process.env.REACT_APP_API_BASE_URL}/api/classes/getClasses?sessionId=${selectedSession}`)
      .then(res => setClasses(res.data))
      .catch(err => console.error("Error fetching classes:", err));

    setSelectedClass('');
    setSections([]);
    setSelectedSection('');
  }, [selectedSession]);

  // Fetch sections when class changes
  useEffect(() => {
    if (!selectedClass || !selectedSession) {
      setSections([]);
      setSelectedSection('');
      return;
    }

    const selectedClassName = classes.find(c => c._id === selectedClass)?.className;
    if (!selectedClassName) return;

    axios.get(` ${process.env.REACT_APP_API_BASE_URL}/api/sections/${encodeURIComponent(selectedClassName)}/getSectionsByClassName?sessionId=${selectedSession}`)
      .then(res => {
        const data = Array.isArray(res.data) ? res.data : res.data.sections || [];
        setSections(data);
        setSelectedSection('');
      })
      .catch(err => {
        console.error("Failed to fetch sections:", err);
        setSections([]);
      });
  }, [selectedClass, selectedSession, classes]);
useEffect(() => {
  if (!selectedClass || !selectedSection || !selectedSession) {
    setAlreadySubmitted(false);
    return;
  }

  const selectedClassName =
    classes.find(c => c._id === selectedClass)?.className;

  if (!selectedClassName) return;

  const today = new Date().toISOString().split('T')[0];

  const storageKey = `attendance_${selectedSession}_${selectedClassName}_${selectedSection}_${today}`;

  const isSubmitted = localStorage.getItem(storageKey) === 'true';

  setAlreadySubmitted(isSubmitted);
}, [selectedClass, selectedSection, selectedSession, classes]);

  // Fetch students and attendance data when class, section or session changes
  useEffect(() => {
    if (!selectedClass || !selectedSection || !selectedSession) {
      setStudents([]);
      setAttendance([]);
      setAlreadySubmitted(false);
      return;
    }

    const selectedClassName = classes.find(c => c._id === selectedClass)?.className;
    if (!selectedClassName) {
      console.log("Class not found");
      setStudents([]);
      setAttendance([]);
      return;
    }

    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents`, {
      params: {
        class: selectedClassName,
        section: selectedSection,
        sessionId: selectedSession,
        status: "active",
      },
    })
    .then((res) => {
      const studentsData = res.data;

      const filtered = studentsData.filter(stu => stu.class === selectedClassName && stu.section.toLowerCase() === selectedSection.toLowerCase() && stu.session === selectedSession);

      setStudents(filtered);
      setAttendance(filtered.map((stu) => ({
        rollNo: stu.rollNo,
        studentId: stu._id,
        date: new Date(),
        status: "Present",
        remark: "",
      })));
    })
    .catch((err) => {
      console.error("Error fetching students:", err);
    });
  }, [selectedClass, selectedSection, selectedSession, classes]);

  // Handle attendance change
  const handleChange = (index, event) => {
    const updated = [...attendance];
    updated[index][event.target.name] = event.target.value;
    setAttendance(updated);
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
alert("Submitting attendance for " + students.length + " students.");
    if (alreadySubmitted) {
      alert("Attendance for this class & section has already been submitted today!");
      return;
    }

    const selectedClassName = classes.find(c => c._id === selectedClass)?.className;

    const payload = {
      sessionId: selectedSession,
      className: selectedClassName,
      sectionName: selectedSection,
      students: attendance,
    };

    axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/attendance/createOrUpdateAttendance`, payload)
      .then(() => {
        alert(`Attendance submitted for ${selectedClassName} (${selectedSection})`);
        setAlreadySubmitted(true);
        window.dispatchEvent(new Event('attendanceUpdated'));

        const today = new Date().toISOString().split('T')[0];

const storageKey = `attendance_${selectedSession}_${selectedClassName}_${selectedSection}_${today}`;

localStorage.setItem(storageKey, 'true');

      })
      .catch(err => {
        console.error(err);
        alert(err.response?.data?.message || 'Failed to submit attendance.');
      });
  };

  // Filter students based on search query
  const filteredStudents = students.filter(stu => 
    String(stu.rollNo).includes(searchQuery) || stu.firstName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <form onSubmit={handleSubmit} className="w-full mx-auto p-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div>
          <label className={labelStyle}>Class Name</label>
          <select
            value={selectedClass}
            onChange={e => setSelectedClass(e.target.value)}
            className={inputStyle}
            disabled={!selectedSession}
          >
            <option value="">Select Class</option>
            {classes.map(c => <option key={c._id} value={c._id}>{c.className}</option>)}
          </select>
        </div>

        <div>
          <label className={labelStyle}>Section Name</label>
          <select
            value={selectedSection}
            onChange={e => setSelectedSection(e.target.value)}
            className={inputStyle}
            disabled={!selectedClass}
          >
            <option value="">Select Section</option>
            {sections.map(s => <option key={s._id} value={s.sectionName}>{s.sectionName}</option>)}
          </select>
        </div>
      </div>

      {alreadySubmitted && <p className="text-red-600 font-semibold mb-4">Attendance already submitted today for this class & section.</p>}

      <div className="mb-6">
        <label className={labelStyle}>Search Student:</label>
        <input
          type="text"
          placeholder="Search by roll no or name"
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
          className={`${inputStyle} md:w-1/3`}
        />
      </div>

      {filteredStudents.length > 0 ? (
        <div className="overflow-x-auto mb-6">
          <table className="min-w-full bg-white border border-gray-300 text-center">
            <thead className="bg-gray-200">
              <tr>
                <th className="py-2 px-4 border text-[18px] font-semibold text-black">Roll No</th>
                <th className="py-2 px-4 border text-[18px] font-semibold text-black">Student Name</th>
                <th className="py-2 px-4 border text-[18px] font-semibold text-black">Father Name</th>
                <th className="py-2 px-4 border text-[18px] font-semibold text-black">Status</th>
                <th className="py-2 px-4 border text-[18px] font-semibold text-black">Remark</th>
              </tr>
            </thead>
            <tbody>
              {filteredStudents.map((stu, index) => (
                <tr key={stu._id} className="hover:bg-gray-100">
                  <td className="border px-4 py-2 text-[14px]">{stu.rollNo}</td>
                  <td className="border px-4 py-2 text-[14px]">{stu.firstName + " " + stu.lastName}</td>
                  <td className="border px-4 py-2 text-[14px]">{stu.fatherName}</td>
                  <td className="border px-4 py-2">
                    <select
                      name="status"
                      value={attendance[index]?.status || 'Present'}
                      onChange={e => handleChange(index, e)}
                      className={inputStyle}
                      disabled={alreadySubmitted}
                    >
                      <option value="Present">Present</option>
                      <option value="Absent">Absent</option>
                      <option value="Late">Late</option>
                      <option value="onLeave">On Leave</option>
                    </select>
                  </td>
                  <td className="border px-4 py-2">
                    <input
                      type="text"
                      name="remark"
                      placeholder="Enter remark"
                      value={attendance[index]?.remark || ''}
                      onChange={e => handleChange(index, e)}
                      className={inputStyle}
                      disabled={alreadySubmitted}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p>No students found for this class and section.</p>
      )}

      <button
        type="submit"
        className={`px-6 py-3 rounded-md text-white font-semibold transition ${alreadySubmitted ? 'bg-gray-500 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'}`}
        disabled={alreadySubmitted}
      >
        {alreadySubmitted ? 'Attendance Already Submitted' : 'Submit Attendance'}
      </button>
    </form>
  );
};

export default AddAttendance;